module.exports = __webpack_public_path__ + "img/verde.52c0fb5b.svg";